import React from 'react'

const Social = () => {
  return (
    <div className="home__social">
        <a href="https://www.instagram.com/kumkum_227" className="home__social-icon" target="_blank">
            <i class="uil uil-instagram"></i>
        </a>

        <a href="https://www.linkedin.com/in/kumkum-sharma-903323224" className="home__social-icon" target="_blank">
        <i class="uil uil-linkedin-alt"></i>
        </a>

        <a href="https://github.com/kumkumshh" className="home__social-icon" target="_blank">
        <i class="uil uil-github-alt"></i>
        </a>

    </div>
  )
}

export default Social
